import { render, staticRenderFns } from "./AlertIndex.vue?vue&type=template&id=3f9a3751"
import script from "./AlertIndex.vue?vue&type=script&lang=js"
export * from "./AlertIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports